import {BaseModelService} from './BaseModelService';
import {ProductGroup} from '../Models';

export class ProductGroupService extends BaseModelService<ProductGroup> {
  constructor(apiUrl: string = '') {
    super(ProductGroup);
    this.apiBaseUrl = `${apiUrl}/v1/inventory/public/product-groups`;
  }
}
